/**
 * Not-found page (framing R2).
 *
 * Prerendered to `dist/404.html`, which Caddy serves with a real 404
 * status for any path outside the route inventory; also rendered
 * client-side when in-app navigation reaches an unknown path.
 */

import Link from './Link';
import './NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <main className="not-found">
      <div className="not-found-card">
        <p className="not-found-code">404</p>
        <h1>Page not found</h1>
        <p className="not-found-text">
          There is no page at this address. The links below cover everything on the site.
        </p>
        <ul className="not-found-list">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/app">Open the time-distance diagram tool</Link></li>
          <li><Link to="/docs" event="docs-open" source="not-found">Documentation</Link></li>
          <li><Link to="/learn/time-distance-diagram" event="learn-open" source="not-found">What is a time-distance diagram?</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </div>
    </main>
  );
}
